import { PlanComparisonTable } from '../../components/PlanComparisonTable';

type Props = {
  selectedPlan: string;
  onPlanChange: (plan: string) => void;
  onSelectAndNext: (plan: string) => void;
  onSelectFree?: () => void;
  currentPlan: string | undefined;
  /** Current currency code (e.g. 'usd', 'eur') */
  currency?: string;
  /** Called when user changes currency in the selector */
  onCurrencyChange?: (currency: string) => void;
  /** Disable currency selector (paid users with existing subscription) */
  currencyDisabled?: boolean;
  /** Minimum plan required — hides plans below this level */
  minPlanRequired?: string;
};

export function WizardStepPlan({
  selectedPlan,
  onPlanChange,
  onSelectAndNext,
  onSelectFree,
  currentPlan,
  currency,
  onCurrencyChange,
  currencyDisabled,
  minPlanRequired,
}: Props) {
  return (
    <div className="py-4">
      <PlanComparisonTable
        value={selectedPlan}
        onChange={onPlanChange}
        onSelectAndNext={onSelectAndNext}
        onSelectFree={onSelectFree}
        currentPlan={currentPlan}
        currency={currency}
        onCurrencyChange={onCurrencyChange}
        currencyDisabled={currencyDisabled}
        minPlanRequired={minPlanRequired}
      />
    </div>
  );
}
